import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostForm from './PostForm';

function NewPost() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    toast.success('Post created successfully!');
    navigate('/posts');
  };

  const handleCancel = () => {
    navigate('/posts');
  };

  return (
    <div className="main-content">
      <div className="container">
        <PostForm 
          onSuccess={handleSuccess} 
          onCancel={handleCancel} 
        />
      </div>
    </div>
  );
}

export default NewPost;